module.exports = "<monitoring-dashboard [entityIdDetails]=\"entityIdDetails\">Loading...</monitoring-dashboard>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/entitymonitoringperson/entity-monitoring-person.component.html
// module id = 2250
// module chunks = 0